let id = 0;


export const uniqueId = {
    /**
     * @description generates a unique id
     * @param {string} prefix - the prefix to add to the id
     * @param {number} offset - the offset to add to the id
     * @returns {string} the unique id
     */
    next: (prefix = "", offset = 0) => {
        if (typeof prefix !== "string") prefix = "";
        if (isNaN(parseInt(Number(offset)))) offset = 0;
        return prefix + (++id + offset);
    },
    /**
     * @description resets the id to 0
     */
    reset: () => {
        id = 0;
    },
    /**
     * 
     * @returns {number} the current id
     */
    current: () => id,
    /**
     * @description sets the id
     * @param {number} value 
     */
    set: (value) => {
        if (!isNaN(parseInt(Number(value)))) id = value;
    }
}